import { hideableValueCreateHidden } from "@wix/devzai-utils-common";
import {doppeActionTypeDefineMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata,
    BymoPagePropsSpecialContentSettingMetadata,
    DoppeAutomationTriggers,
    doppePremiumFeatureIsDisabled,
    DoppePremiumFeatures
} from '../../client-server-common';
import type {WixMediaResource} from '@wix/devzai-common-wix';
import type {DoppeCheckoutActionSettings} from '../../client-server-common/types/doppe-checkout-action-settings';
import {
    doppeCheckoutActionCheckoutSettingsResolveForAction,
    prepareCheckoutSettingsForViewer
} from '../../client-server-common/types/doppe-checkout-action-settings';
import type {DoppeActionPrice} from '../../client-server-common/types/doppe-action-price';
import type { RichTextContent, HideableValue } from "@wix/devzai-utils-common";

export namespace DoppeActionTypeRequest {

    export interface RequestOption {
        title: string;
        description: HideableValue<RichTextContent>;
        priceData: DoppeActionPrice;
        images: WixMediaResource[] | null;
        fulfillmentDetails: HideableValue<RichTextContent>;
        requestsInstructions: HideableValue<RichTextContent>;
        previewCheckoutButtonText: HideableValue<string>;
        showNotesInput: boolean;
        ribbon: HideableValue<string>;
        id: string;
    }

    export interface ActionSettings extends
        RequestOption,
        DoppeCheckoutActionSettings {
        previewCheckoutButtonText: string,
    }

}


export const doppeActionTypeRequest = doppeActionTypeDefineMetadata<DoppeActionTypeRequest.ActionSettings>({
    id: 'co.hopp.action/request-item',
    resolveActionSettings: action => {

        const {
            checkoutSettings,
            ...restSettings
        } = action.settings;


        return {
            id: '',
            title: '',
            description: hideableValueCreateHidden(''),
            priceData: {
                actualPrice: 0,
                currencyCode: 'USD',
            },
            images: null,
            showNotesInput: true,
            requestsInstructions: hideableValueCreateHidden(''),
            fulfillmentDetails: hideableValueCreateHidden(''),
            previewCheckoutButtonText: 'Checkout',
            ribbon: hideableValueCreateHidden('SALE'),
            ...restSettings,
            checkoutSettings: doppeCheckoutActionCheckoutSettingsResolveForAction(checkoutSettings)
        }
    },
    prepareForViewer: actionSettings => {
        prepareCheckoutSettingsForViewer(actionSettings);
    },
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            id: BymoPagePropsSpecialContentSettingMetadata.Unknown,
            title: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityTitle),
            description: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.RichText, BymoPagePropsContentSettingSemanticMeaning.EntityDescription),
            images: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.MultipleMedia, BymoPagePropsContentSettingSemanticMeaning.EntityMedia),
            fulfillmentDetails: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.RichText, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
            requestsInstructions: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.RichText, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
            previewCheckoutButtonText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityActionButtonText),
            ribbon: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityRibbon)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {
                description: true,
                fulfillmentDetails: true,
                requestsInstructions: true,
                ribbon: true
            }
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    isPaymentAction: true,
    getSupportedAutomationTrigger: () => DoppeAutomationTriggers.PaymentReceived,
    isFormAction: false,
    isPremiumAction: (premiumFeaturesStatus) => {
        return doppePremiumFeatureIsDisabled(premiumFeaturesStatus, DoppePremiumFeatures.creators_monetization_actions)
    },
});
